import React from 'react';

import './Grid.css';

export default ({ primaryClassName, children, className, ...props }) => (
  <div className={`${primaryClassName}${className ? ` ${className}` : ''}`} {...props}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/basic/grid/GridComponent.js